<template>
  <div>
    <el-form
      :data="subscriberInfo"
      label-width="80px"
      size="mini"
      label-position="left"
      disabled
    >
      <el-row>
        <!-- <el-col :span="8">
          <el-form-item label="头像">
            <el-avatar :src="subscriberInfo.avatar"></el-avatar>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="昵称">
            <el-input v-model="subscriberInfo.nickname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号">
            <el-input v-model="subscriberInfo.phoneNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别">
            <el-select
              v-model="subscriberInfo.gender"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in genderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生日">
            <el-input v-model="subscriberInfo.birthday"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="省">
            <el-input v-model="subscriberInfo.province"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="市">
            <el-input v-model="subscriberInfo.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="区">
            <el-input v-model="subscriberInfo.county"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="详细地址">
            <el-input v-model="subscriberInfo.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="注册时间">
            <el-input v-model="subscriberInfo.createTime"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分享码">
            <el-input v-model="subscriberInfo.shareCode"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { getSubscriberInfoApi } from "@/api/subscriber";
export default {
  name: "subscriberInfo",
  props: {
    subscriberId: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      genderOptions: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
        { label: "未知", value: 0 }
      ],
      subscriberInfo: {},
      loading: false
    };
  },
  watch: {
    subscriberId: {
      immediate: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.subscriberId = val;
        this.getSubscriberInfo(val);
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    getSubscriberInfo(v) {
      if (!v) {
        return;
      }
      this.loading = true;
      getSubscriberInfoApi(v)
        .then(res => {
          if (res.data.status == 100) {
            this.subscriberInfo = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// subscriberInfo.vue?812e1492